export function saveFormDataToLocal(formId, data) {
  const key = `formData_${formId}`;
  localStorage.setItem(key, JSON.stringify(data));
}

export function getFormDataFromLocal(formId) {
  const key = `formData_${formId}`;
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : null;
}

export function clearFormDataFromLocal(formId) {
  const key = `formData_${formId}`;
  localStorage.removeItem(key);
}